<div class="dash-news-dialog-component">
    <div class="dash-news-dialog-component__header-container">
        <div class="dash-news-dialog-component__header-title">
            <img src="/images/nucont-yellow-icon.png" alt="Nucont" />
            <h3 class="dash-news-dialog-component__header-title-text">
                Novidades Nucont
            </h3>
        </div>
        <dsn-button-rounded
            type="secondary"
            icon="fa-solid fa-xmark"
            size="medium"
            (click)="dialogRef.close()"
        ></dsn-button-rounded>
    </div>
    <div class="dash-news-dialog-component__content">
        <div class="dash-news-dialog-component__image-container">
            <img src="/images/dash-news.png" alt="Nucont" />
        </div>
        <div class="dash-news-dialog-component__text-container">
            <h3 class="dash-news-dialog-component__text-container-title">
                Conheça o Dash, a nova ferramenta Nucont
            </h3>
            <p class="dash-news-dialog-component__text-container-description">
                Uma experiência interativa e visual que substitui o antigo
                relatório e transforma a análise para o seu cliente.
            </p>
            <div class="dash-news-dialog-component__text-container-items">
                <div class="dash-news-dialog-component__text-container-item">
                    <div
                        class="dash-news-dialog-component__text-container-item-image"
                    >
                        <img
                            src="/images/explore-more.png"
                            alt="Explore Mais"
                        />
                    </div>
                    <div
                        class="dash-news-dialog-component__text-container-item-content"
                    >
                        <h3
                            class="dash-news-dialog-component__text-container-subtitle"
                        >
                            Explore Mais
                        </h3>
                        <p
                            class="dash-news-dialog-component__text-container-subtitle-description"
                        >
                            Interações nos indicadores com atualização
                            instantânea. Drilldown e navegação interativa nos
                            gráficos.
                        </p>
                    </div>
                </div>
                <div class="dash-news-dialog-component__text-container-item">
                    <div
                        class="dash-news-dialog-component__text-container-item-image"
                    >
                        <img
                            src="/images/content.png"
                            alt="Conteúdos inéditos"
                        />
                    </div>
                    <div
                        class="dash-news-dialog-component__text-container-item-content"
                    >
                        <h3
                            class="dash-news-dialog-component__text-container-subtitle"
                        >
                            Conteúdos inéditos
                        </h3>
                        <p
                            class="dash-news-dialog-component__text-container-subtitle-description"
                        >
                            Performance da empresa com base em referências
                            técnicas. Benchmarking gratuito com indicadores
                            selecionados.
                        </p>
                    </div>
                </div>
                <div class="dash-news-dialog-component__text-container-item">
                    <div
                        class="dash-news-dialog-component__text-container-item-image"
                    >
                        <img
                            src="/images/icon-AI.png"
                            alt="Chat com IA Nanda"
                        />
                    </div>
                    <div
                        class="dash-news-dialog-component__text-container-item-content"
                    >
                        <h3
                            class="dash-news-dialog-component__text-container-subtitle"
                        >
                            Chat com IA Nanda
                        </h3>
                        <p
                            class="dash-news-dialog-component__text-container-subtitle-description"
                        >
                            Inteligência artificial integrada à ferramenta
                            oferecendo assistência rápida e automatizada.
                        </p>
                    </div>
                </div>
                <div class="dash-news-dialog-component__text-container-item">
                    <div
                        class="dash-news-dialog-component__text-container-item-image"
                    >
                        <img
                            src="/images/versatility.png"
                            alt="Entregas de qualidade"
                        />
                    </div>
                    <div
                        class="dash-news-dialog-component__text-container-item-content"
                    >
                        <h3
                            class="dash-news-dialog-component__text-container-subtitle"
                        >
                            Entregas de qualidade
                        </h3>
                        <p
                            class="dash-news-dialog-component__text-container-subtitle-description"
                        >
                            Acesso em qualquer dispositivo com edições em tempo
                            real. Envios automáticos via WhatsApp e e-mail.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="dash-news-dialog-component__button-container">
        <dsn-button
            [label]="'Explorar Novidades'"
            [type]="'primary'"
            [size]="'medium'"
            [disabled]="false"
            (onClick)="dialogRef.close()"
        ></dsn-button>
    </div>
</div>
